// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"d18822d3","297":"58b86ff3","643":"037a3923","787":"63357a40","959":"0aa97dfe"}[chunkId] + ".chunk.js";
};